import DocumentRouter from './DocumentRouter'

export default DocumentRouter
